/** @jsxImportSource @emotion/react */
import { Box } from '@mui/material';
import { css } from '@emotion/react';
import brandLogos from '../../Assets/BrandLogos/brandLogos';

const HeadlineLogo = ({ logo }) => {
  const Logo = brandLogos[logo];
  return (
    <Box
      css={css({
        maxHeight: 50,
        maxWidth: 200,
      })}
      data-testid="headlineLogo"
    >
      <Logo />
    </Box>
  );
};

export default HeadlineLogo;
